import httpAdmin from '@/httpCommon/axiosClient';
import { TypeCardDownload } from '@/types/card';

class RevenueService {
    getRevenueReport = async (params: any) => {
        const res = await httpAdmin.get('/revenue', { params });
        return res?.data;
    };

    getRevenueReportDownload = async (params: any) => {
        const res = await httpAdmin.get('/revenue/download', { params });
        return res?.data;
    };

    getRevenueDetail = async (id: number | undefined) => {
        const res = await httpAdmin.get(`/revenue/${id}`);
        return res?.data;
    };

    getRevenueDetailDownload = async (id: number | undefined) => {
        const res = await httpAdmin.get(`/revenue/download/${id}`);
        return res?.data;
    };

    cardReportDownload = async (params?: TypeCardDownload) => {
        const res = await httpAdmin.get(`/card-info/download`, { params });
        return res.data;
    };

    cardReport = async (params?: any) => {
        const res = await httpAdmin.get(`/card-info/revenue`, { params });
        return res?.data;
    };

    seatMonthlyReport = async (params?: any) => {
        const res = await httpAdmin.get(`/room/monthly`, { params });
        return res?.data;
    };

    seatMonthlyReportDownload = async (params?: TypeCardDownload) => {
        const res = await httpAdmin.get(`/room/monthly/download`, { params });
        return res.data;
    };

    quicklyReport = async (params?: any) => {
        const res = await httpAdmin.get(`/revenue/quickly`, { params });
        return res?.data;
    };

    quicklyReportDownload = async (params?: any) => {
        const res = await httpAdmin.get(`/revenue/quickly/download`, { params });
        return res.data;
    };

    dailyReport = async (params?: any) => {
        const res = await httpAdmin.get(`/revenue/daily-report`, { params });
        return res.data;
    };

    dailyReportDownload = async (params?: any) => {
        const res = await httpAdmin.get(`/revenue/daily-report/download`, { params });
        return res.data;
    };
}
export default new RevenueService();
